/**
 * Format a number as Indian Rupee (INR) currency
 */
export function formatINR(amount: number | string): string {
  const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;

  if (isNaN(numAmount)) {
    return '₹0.00';
  }

  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(numAmount);
}

/**
 * Parse an INR formatted string back to number
 */
export function parseINR(inrString: string): number {
  // Remove currency symbol and commas
  const cleaned = inrString.replace(/₹|,/g, '');
  return parseFloat(cleaned) || 0;
}

/**
 * Format amount for display in forms (without currency symbol for input fields)
 */
export function formatAmountForInput(amount: number | string): string {
  const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;

  if (isNaN(numAmount)) {
    return '0.00';
  }

  return numAmount.toFixed(2);
}

/**
 * Parse amount from input field
 */
export function parseAmountFromInput(input: string): number {
  const cleaned = input.replace(/,/g, '');
  const parsed = parseFloat(cleaned);

  if (isNaN(parsed) || parsed < 0) {
    return 0;
  }

  return parsed;
}